import React, { useContext } from 'react';
import { Platform, StyleSheet, Text } from 'react-native';
import PropTypes from 'prop-types';
import LayoutContext from '../../contexts/Layout';

const Paragraph2 = ({ numberOfLines, text, extraStyle }) => {
    const { layout } = useContext(LayoutContext);

    return (
        <Text
            dataSet={{
                tagName: 'P2',
                fontFamily: layout.styleGuide.p2.fontFamily,
                condensedFontFamily: layout.styleGuide.p2.condensedFontFamily,
                fontSize: layout.styleGuide.p2.fontSize,
                color: layout.styleGuide.p2.color
            }}
            numberOfLines={numberOfLines}
            style={StyleSheet.flatten([Style.p2, layout.styleGuide.p2, extraStyle])}
        >
            {text}
        </Text>
    );
};

const Style = StyleSheet.create({
    p2: {
        color: '#8897A2',
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '13pt' : 13,
        letterSpacing: 0,
        lineHeight: Platform.OS.equals('web') ? '19pt' : 19
    }
});

Paragraph2.propTypes = {
    extraStyle: PropTypes.object,
    numberOfLines: PropTypes.number,
    text: PropTypes.string
};

export default Paragraph2;
